import { Box, Button } from "@mui/material";
import React, { useContext } from "react";
import { LanguageContext } from "../../../components/language";
import CancelIcon from "@mui/icons-material/Cancel";

const AddPerson = ({ nomers, addNomer, changeNumber, maxGuest, close }) => {
  const { t } = useContext(LanguageContext);

  return (
    <div className="nomers">
      {nomers.map((item, i) => (
        <div className="nomer" key={i}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <p className="nomer-title">
              {t("NUMBER")} {i + 1}
            </p>
            {i > 0 && <CancelIcon onClick={() => changeNumber({ index: i, value: { ...item, people: 0 } })} color="error" />}
          </Box>
          <Box justifyContent={"space-between"} display={"flex"} alignItems="center" mb={"15px"}>
            <span>{t("ADULT")} 18+</span>
            <Box className="nomers__button-group">
              <button disabled={item.people === 1} onClick={() => changeNumber({ index: i, value: { ...item, people: item.people - 1, ...(item.people === 1 ? { children: 0 } : {}) } })}>
                -
              </button>
              <div>{item.people || 0}</div>
              <button onClick={() => item.people + item.children < maxGuest && changeNumber({ index: i, value: { ...item, people: item.people + 1 } })}>+</button>
            </Box>
          </Box>
          <Box justifyContent={"space-between"} display={"flex"} alignItems="center">
            <span>
              {t("CHILDREN")} 3-17 {t("YEAR")}
            </span>
            <Box className="nomers__button-group">
              <button disabled={!item.children} onClick={() => changeNumber({ index: i, value: { ...item, children: item.children - 1 } })}>
                -
              </button>
              <div>{item.children || 0}</div>
              <button disabled={!item.people} onClick={() => item.people + item.children < maxGuest && changeNumber({ index: i, value: { ...item, children: item.children + 1 } })}>
                +
              </button>
            </Box>
          </Box>
        </div>
      ))}
      <Box onClick={addNomer} display={"flex"} justifyContent="center" my="15px">
        <Button fullWidth>+ {t("ADD_ROOM")}</Button>
      </Box>
      <div onClick={close} className={"close-add-person"}>
        {t("SAVE")}
      </div>
    </div>
  );
};

export default AddPerson;
